import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import {store} from "@/store";
import Vue3Toasity, {type ToastContainerOptions, toast} from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

createApp(App)
	.use(Vue3Toasity,
		{
			autoClose: 1000,
			icon: true,
			hideProgressBar: true,
			theme: 'dark',
			transition: toast.TRANSITIONS.BOUNCE,
			limit: 1,
		} as ToastContainerOptions)
	.use(router)
	.use(store)
	.mount('#app')

// Stop recurring error when changing views
if (typeof ResizeObserver !== 'undefined') {
	const resizeObserverErrHandler = () => {
		let resizeObserverErr = null;
		window.addEventListener('error', (err) => {
			if (err.message === 'ResizeObserver loop completed with undelivered notifications.') {
				resizeObserverErr = err;
				err.stopImmediatePropagation();
			}
		});
		const observer = new ResizeObserver(() => {
		});
		observer.observe(document.body);
	};
	resizeObserverErrHandler();
}
